import { arrayIncludes } from '@ag1/ui';
import { PageSection } from '@portal/types/studio/page';
import { SlimSectionTypes } from './componentsMap';
import { ContentBlockName, SlimContentBlockNames } from './contentBlockComponentsMap';
import { isSectionType } from './utils';
import type { AssetLibrarySection } from '../DynamicLanders/types';

/**
 * When rendering sections, we need to determine if they are visible on page
 * load or not. Since we have to determine this statically, we do our best
 * effort based on how "large" the section is.
 */
export const createVisibleOnPageLoadCalculator = () => {
  type SectionInput = {
    section?: PageSection | AssetLibrarySection | undefined;
    customSectionName?: ContentBlockName;
  };

  let points = 0;
  return ({ section, customSectionName }: SectionInput) => {
    if (
      (section && isSectionType(section, SlimSectionTypes)) ||
      (customSectionName && arrayIncludes(SlimContentBlockNames, customSectionName))
    ) {
      points += 1;
    } else {
      points += 2;
    }

    return points <= 3;
  };
};
